module.exports = __webpack_public_path__ + "img/placeholder.f3d99e33.jpg";